module.exports = {
  SHOPIFY_API_VERSION: '2020-01',
};
